
const initialState = {
  personalInfo: {},         // object for autofill
  workExperience: [],
  education: [],
  keySkills: [],
  templatePage: [],
  addHobies: [],
  addSoftSkills: [],
  addLanguage: [],
  socialMediaLinks: [],
  honorAndaward: [],
  addReference: [],
  coverletterss: [],
  certificateData: [],
  projectData: [],
  images: [],
  techImages: [],
  coverImages: [],           
  shadiData: [],
  shadicarddata: [],
  selectedIcon: [],
  googleData: [],
  friend_To_Talk:[],
  personalInfoData:[],
  coverLetterData:[],
  experienceLetterData:{},
  offerLetterData:{},
  setTemplatePage:[],
  extractedResumeText: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "personalinfo_data":
      return {
        ...state,
        personalInfo: action.payload, // object hi rakho
      };
    case "workEx_data":
      return {
        ...state,
        workExperience: action.payload ,
      };
    case "education_data":
      return {
        ...state,
        education: Array.isArray(action.payload)
      ? action.payload
      : [action.payload]
      };
    case "keyskills_data":
      return {
        ...state,
        keySkills: Array.isArray(action.payload)
      ? action.payload
      : [action.payload]
      };
    case "template_page":
      return {
        ...state,
        templatePage: action.payload ? [action.payload] : [],
      };
    case "add_Hobbies":
      return {
        ...state,
        addHobies: Array.isArray(action.payload)
      ? action.payload
      : [action.payload]
      };
    case "add_soft_skills":
      return {
        ...state,
        addSoftSkills: action.payload
      };
    case "add_Language":
      return {
        ...state,
        addLanguage: Array.isArray(action.payload)
      ? action.payload
      : [action.payload]
      };
    case "social_media":
      return {
        ...state,
        socialMediaLinks: Array.isArray(action.payload)
      ? action.payload
      : [action.payload]
      };
    case "honor_and_award":
      return {
        ...state,
        honorAndaward: Array.isArray(action.payload)
      ? action.payload
      : [action.payload]
      };
    case "add_references":
      return {
        ...state,
        addReference: Array.isArray(action.payload)
      ? action.payload
      : [action.payload]
      };
    case "cover_letter":
      return {
        ...state,
        coverletterss: action.payload ? [action.payload] : [],
      };
    case "certificate_Data":
      return {
        ...state,
        certificateData: action.payload
      };
    case "Project_Data":
      return {
        ...state,
        projectData: Array.isArray(action.payload)
      ? action.payload
      : [action.payload]
      };
    case "LOAD_IMAGES":
      return {
        ...state,
        images: action.payload ? [action.payload] : [],
      };
    case "TECH_IMAGES":
      return {
        ...state,
        techImages: action.payload ? [action.payload] : [],
      };
    case "COVER_IMAGE":
      return {
        ...state,
        coverImages: action.payload ? [action.payload] : [], // fixed typo
      };
    case "Form_Data":
      return {
        ...state,
        shadiData: action.payload ? [action.payload] : [],
      };
      case "cover-Letter-Data":
      return {
        ...state,
        coverLetterData: action.payload ? [action.payload] : [],
      };
    case "selected_Shadi_Card":
      return {
        ...state,
        shadicarddata: action.payload ? [action.payload] : [],
      };
    case "selected_Icon":
      return {
        ...state,
        selectedIcon: action.payload ? [action.payload] : [],
      };
      case "google_data":
      return {
        ...state,
        googleData: action.payload ? [action.payload] : [],
      };
       case "friendToTalk":
      return {
        ...state,
        friend_To_Talk: action.payload ? [action.payload] : [],
      };
      case "experience-Letter-Data":
        return{
           ...state,
           experienceLetterData: action.payload,
        }
        case "offer-Letter-Data":
          return{
            ...state,
            offerLetterData: action.payload,
          }
        case "set-Template-Page":
          return{
            ...state,
            setTemplatePage: action.payload,
          }  
          case "extracted_resume_text":
    return {
        ...state,
        extractedResumeText: action.payload,
    };
    default:
      return state;
  }
};

export default reducer;
